export const showChat = async () => {
    if (window.Gladly?.getAvailability()) {
        window.Gladly.show()
    }
}


